// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"313":"promo-packs","617":"merge-calibers","741":"merge-suppliers","856":"merge-manufacturers","966":"merge-products"}[chunkId] + "." + {"313":"e6b6684e","617":"1d6193e9","741":"90170f50","856":"807a0e27","966":"9cb3158a"}[chunkId] + ".css";
};